/** API route map: URLS.Controller.JobRecommendation */
export const JobRecommendation = {
      Name: 'jobRecommendation/',
      GetAll: 'job-recommendation',
};
